import { match } from 'ts-pattern';

import type { PublicPosition } from '../services/interfaces/positions.types';
import type { PositionTrend } from '../types/positions.types';

export function getPositionCurrentPrice(position: PublicPosition): number | undefined {
  const { market } = position;

  return position.side === 'yes'
    ? (market.last_price_yes ?? market.price_yes?.numeric_price)
    : (market.last_price_no ?? market.price_no?.numeric_price);
}

export function getPositionPayout(position: PublicPosition): number {
  return position.total_proceeds ?? 0;
}

export function isPositionLoss(position: PublicPosition): boolean {
  return position.status === 'closed' && getPositionPayout(position) === 0;
}

export function getPositionPnl(position: PublicPosition): number {
  return match(position.status)
    .returnType<number>()
    .with('closed', () => position.realized_pnl)
    .with(
      'open',
      () => (getPositionCurrentPrice(position) ?? 0) * position.quantity - position.cost_plus_fees
    )
    .exhaustive();
}

export function getTrendFromAmount(amount: number): PositionTrend {
  if (amount > 0) return 'up';
  if (amount < 0) return 'down';

  return 'flat';
}

export function getPositionTrend(position: PublicPosition): PositionTrend {
  if (isPositionLoss(position)) return 'flat';
  if (position.status === 'open' && getPositionCurrentPrice(position) == null) return 'flat';

  return getTrendFromAmount(getPositionPnl(position));
}
